import apiClient from './apiClient'

const getTodos = (tenant, projectId, allProjects) => {
  const params = {
    allProjects
  }
  return apiClient.get(`/${tenant}/ToDo/${projectId}`, { params })
}

const getTodoByById = (tenant, params) => {
  return apiClient.get(`/${tenant}/ToDo/${params.projectId}/${params.toDoId}`, { params })
}

const createTodo = (tenant, projectId, todo) => {
  return apiClient.post(`/${tenant}/ToDo/${projectId}`, todo)
}

const updateTodo = (tenant, projectId, todoId, todo) => {
  return apiClient.put(`/${tenant}/ToDo/${projectId}/${todoId}`, todo)
}

const deleteTodo = (tenant, projectId, todoId) => {
  return apiClient.delete(`/${tenant}/ToDo/${projectId}/${todoId}`)
}


export default {
  getTodos,
  getTodoByById,
  createTodo,
  updateTodo,
  deleteTodo
}
